import { CommonListParams } from "@/types/common";
import { ProductInfoAdd, ProductInfoAttachmentAdd, ProductInfoData, ProductInfoStateEnum } from "@/types/productInfo"
import request from ".";





const PRODUCT_APIS = {
  stateList: (state?: ProductInfoStateEnum) => `/wms/production/manual/${state !== undefined ? state + '/' : ''}list`,
  enable: (id: string) => `/wms/production/manual/${id}/enable`,
  disable: (id: string) => `/wms/production/manual/${id}/disable`,
  add: `/wms/production/manual/add`,
  update: (id: string) => `/wms/production/manual/${id}/update`,
  get: (id: string) => `/wms/production/manual/${id}/get`,


  //附件
  attachmentAdd: (id: string) => `/wms/production/manual/${id}/attachment/add`,
  attachmentDisable: `/wms/production/manual/attachment/disable`,
  attachmentUpdate: (id: string) => `/wms/production/manual/attachment/${id}/description/update`,

}


export interface ProductInfoStateListParams {
  state?: ProductInfoStateEnum;
  params?: CommonListParams;
}

export const stateList = (data: ProductInfoStateListParams) => {
  return new Promise<CommonListParams<Array<ProductInfoData>>>((resolve, reject) => {
    request<Array<ProductInfoData>, string>(PRODUCT_APIS.stateList(data.state), { params: data.params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

// 启用生产资料
export const enableProductInfo = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string>(PRODUCT_APIS.enable(id), { method: 'post' })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

// 禁用生产资料
export const disableProductInfo = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string>(PRODUCT_APIS.disable(id), { method: 'post' })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const addOrEdit = (data: ProductInfoAdd, id?: string) => {
  return new Promise<ProductInfoData>((resolve, reject) => {
    request<ProductInfoData, ProductInfoAdd>(id ? PRODUCT_APIS.update(id) : PRODUCT_APIS.add, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};

export const getInfo = (id: string) => {
  return new Promise<ProductInfoData>((resolve, reject) => {
    request<ProductInfoData, undefined>(PRODUCT_APIS.get(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};


export const attachmentAdd = (id: string, data: ProductInfoAttachmentAdd) => {
  return new Promise<void>((resolve, reject) => {
    request<void, ProductInfoAttachmentAdd>(PRODUCT_APIS.attachmentAdd(id), { params: { body: data } })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const attachmentDisable = (ids: Array<string>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, Array<string>>(PRODUCT_APIS.attachmentDisable, { params: { body: ids } })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const attachmentUpdate = (id: string, desc: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string>(PRODUCT_APIS.attachmentUpdate(id), { params: { body: desc } })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};